// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tower-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 22C6.8 19.2 10 11 10 7H14C14 11 17.2 19.2 20 22H15C15 22 14.5006 19 12 19C9.49942 19 9 22 9 22H4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 3H15V7H9V3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 3H9V7H15V3H12ZM12 3V2M21 22H15C15 22 14.5006 19 12 19C9.49942 19 9 22 9 22H3M10 7C10 10.7837 7.1367 18.3256 4.45713 21.5M14.0071 7C14.0071 10.7837 16.8705 18.3256 19.55 21.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Tower1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tower-1',
    ref,
    icon: element,
  },
));

Tower1Icon.displayName = 'Tower1Icon';

export default Tower1Icon;
